// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JUbt","label":"styles_label__3Ja0I"};